<div class="checkin__booking__detail__dates" [ngClass]="{ 'checkin__booking__detail__dates--no-payments' : !hasPayments }">
  <app-booking-detail-dates-item
    class="checkin__booking__detail__dates__item"
    [ngClass]="{ 'checkin__booking__detail__dates__item--no-payments' : !hasPayments }"
    *ngFor="let date of dates"
    [date]="date">
  </app-booking-detail-dates-item>
</div>
